import { GaAction } from '@ga/ui-components/action'
import { GaIcon } from '@ga/ui-components/icon'

import { GaProductCardFavoriteButton } from '../favorite-button'

import { SIZE } from './scripts/consts'

// @vue/component
export default {
  name: 'ga-product-card-favorite',

  components: {
    GaIcon,
    GaAction,
    GaProductCardFavoriteButton,
  },

  props: {
    size: {
      type: String,
      default: SIZE.S,
      validator: (value) => Object.values(SIZE).includes(value),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    testId: {
      type: String,
      default: '',
    },
  },

  emits: ['click'],

  setup(props) {
    const { size } = toRefs(props)

    const mods = computed(() => ({
      size: unref(size),
    }))

    return {
      mods,
    }
  },
}
